export const config = {
  common: {
    // @ts-ignore
    BASE_URL: process.env.REACT_APP_SERVICE_ENDPOINT,
    END_POINTS: {
      GET_INDUSTRIES: "api/CommonData/get-industries",
      GET_COMPANY_TYPES: "api/CommonData/get-company-types",
      GET_USER_TYPE: "api/CommonData/get-user-types",
      GET_COUNTRIES: "api/CommonData/get-countries",
      GET_FIELDS: "api/CommonData/get-fields",
    },
  },

  tenant_management: {
    // @ts-ignore
    BASE_URL: process.env.REACT_APP_SERVICE_ENDPOINT,
    END_POINTS: {
      GET_TENANT_DETAIL: "api/TenantManagement/get-tenant-detail",
      TENANT_CREATE: "api/TenantManagement/tenant-create",
      TENANT_UPDATE: "api/TenantManagement/tenant-update",
      TENANT_DELETE: "api/TenantManagement/tenant-delete",
      TENANTS_FOR_USER: "api/TenantManagement/user-tenants",
    },
  },

  user_management: {
    // @ts-ignore
    BASE_URL: process.env.REACT_APP_SERVICE_ENDPOINT,
    END_POINTS: {
      GLOBAL_USER_CREATE: "api/UserManagement/global-user-create",
      GLOBAL_USER_UPDATE: "api/UserManagement/global-user-update",
      GLOBAL_USER: "api/UserManagement/global-user",
      GLOBAL_USER_DELETE: "api/UserManagement/global-user-delete",
      TENANT_USER_STAT: "api/UserManagement/tenant-user-statistics",
      SEARCH_USER: "api/UserManagement/search-user",
      CREATE_AD_USER : "api/UserManagement/create-ad-user",
      TENANT_USERS: "api/UserManagement/tenant-users",
    },
  },

  intivation_management: {
    // @ts-ignore
    BASE_URL: process.env.REACT_APP_SERVICE_ENDPOINT,
    END_POINTS: {
      INVITE: "api/InvitationManagement/invite",
      GET_INVITES: "api/InvitationManagement/invite",
      GET_INVITES_BY_TENANT: "api/InvitationManagement/invite-by-tenant",
      ACCEPT_USER_INVITE: "api/InvitationManagement/accept-user-invitation",
      ACCEPT_TENANT_INVITE: "api/InvitationManagement/accept-tenant-invitation",
      REJECT_INVITE: "api/InvitationManagement/reject-invitation",
      READ_INVITE: "api/InvitationManagement/read-invitation",
      RESEND_INVITE: "api/InvitationManagement/resend-invitation",
    },
  },

  catalogue_management: {
    // @ts-ignore
    BASE_URL: process.env.REACT_APP_SERVICE_ENDPOINT,
    END_POINTS: {
      ITEM_CREATE: "api/ItemManagement/item-create",
      ITEM_GET: "api/ItemManagement/item",
      ITEM_UPDATE: "api/ItemManagement/item-update",
      ITEM_DELETE: "api/ItemManagement/item-delete",
      ITEM_CATALOGUE: "api/ItemManagement/tenant-item-catelog",
      ITEMS_PAGED: "api/ItemManagement/item-paged",
      ITEM_TYPE_CREATE: "api/ItemManagement/item-catelog-create",
      ITEM_TYPE_DELETE: "api/ItemManagement/item-catelog-delete",
      ITEM_TYPE_UPDATE: "api/ItemManagement/item-catelog-update",

    },
  },

  blockchain_management: {
    // @ts-ignore
    BASE_URL: process.env.REACT_APP_SERVICE_ENDPOINT,
    END_POINTS: {
      REQUEST_CREATE: "api/RegistrationManagement/request-create",
      REQUEST_UPDATE: "api/RegistrationManagement/request-update",
      REQUEST_GET: "api/RegistrationManagement/request",
      REQUEST_GET_ALL: "api/RegistrationManagement/all-request",
      REQUEST_APPROVAL: "api/RegistrationManagement/request-approve",
      REQUEST_REJECT: "api/RegistrationManagement/request-reject",
      REQUEST_CANCEL: "api/RegistrationManagement/request-cancel",
      REQUEST_BY_HASH: "api/RegistrationManagement/request-by-hash",
      REQUEST_BY_HASH_PUBLIC: "bc/api/RegistrationManagement/verify-block-chain",
    },
  },

  permission_management: {
    // @ts-ignore
    BASE_URL: process.env.REACT_APP_SERVICE_ENDPOINT,
    END_POINTS: {
      ALL_PERMISSION: "api/Permission/all",
      ALL_CATE_PERMISSION: "api/Permission/all-category",
      ALL_USER_CATE_PERMISSION: "api/Permission/user-category",
      CREATE_ROLE: "api/Permission/role-create",
      UPDATE_ROLE: "api/Permission/role-update",
      GET_BY_ROLE_ID: "api/Permission/role/",
      ALL_ROLES: "api/Permission/role/all",
      ASSIGN_USER_N_ROLE: "api/Permission/role",
      REMOVE_USER_N_ROLE: "api/Permission/role/",
    },
  },

  design_management: {
    // @ts-ignore
    BASE_URL: process.env.REACT_APP_SERVICE_ENDPOINT,
    END_POINTS: {
      META_DATA_FIELD_TYPES: "api/ItemManagement/meta-data-field-type",
      TENANT_HIERARCHY: "api/ItemManagement/tenant-hierarchies",
      META_DATA_FIELD_CREATE: "api/ItemManagement/meta-data-field-create",
      META_DATA_FIELD_UPDATE: "api/ItemManagement/meta-data-field-update",
      META_DATA_FIELD_DELETE: "api/ItemManagement/meta-data-field-delete/"
    },
  },

  file_uploader: {
    // @ts-ignore
    BASE_URL: process.env.REACT_APP_SERVICE_ENDPOINT,
    END_POINTS: {
      UPLOAD_FILE_URL: "api/CommonData/get-upload-url"
    },
  },

  category_management: {
    // @ts-ignore
    BASE_URL: process.env.REACT_APP_SERVICE_ENDPOINT,
    END_POINTS: {
      GET_ALL: "api/ItemManagement/all-filed-category",
      ADD: "api/ItemManagement/add-filed-category",
      UPDATE: "api/ItemManagement/update-filed-category",
      DELETE: "api/ItemManagement/filed-category/",
      GET_BY_ID: "api/ItemManagement/filed-category/",
    },
  },
};
